<template>
  <div>
    <SaveInfo
      :isDataUpdating="isDataUpdating"
    ></SaveInfo>
    <div v-if="!isLoading">
<!--      <div class="content_block_top_label">-->
<!--        <p v-if="selectedCompetition?.name">Текущий выбранный конкурс: <strong>{{ selectedCompetition.name }}</strong>-->
<!--        </p>-->
<!--        <p v-if="selectedCompetition?.name" style="margin: 30px 0;"><a class="button2" style=" border: 2px solid #F69F22;" @click.prevent="showModal">Подать заявку на конкурс</a></p>-->
<!--          <p v-else style="margin: 30px 0;"><a class="button2" style=" border: 2px solid #F69F22;" @click.prevent="showModal">Перейти-->
<!--              к отправке на конкурсы</a></p>-->
<!--        <p style="margin-bottom: 30px">Чтобы подать проект на конкурс пройдите в раздел нужного вам конкурса и нажмите-->
<!--          "Подать заявку"</p>-->
<!--      </div>-->

        <template v-if="other_practices">
            <OtherPractices
                    :is-data-updating="isDataUpdating"
                    :is-submitted="isSubmitted"
                    :selectedCompetition="selectedCompetition"
                    @loadCompetition="(val) => { this.loadCompetition(val)}"
                    @loadCompetitions="(val) => { this.loadCompetitions(val)}"
                    @onErrorsChange="(val)=>{this.errors = val;}"
                    @saveBegin="saveBegin"
                    @saveEnd="isDataUpdating=false"
            ></OtherPractices>
				</template>
				<template v-else>
            <FilmForm
                    :is-data-updating="isDataUpdating"
                    :is-submitted="isSubmitted"
                    :selectedCompetition="selectedCompetition"
                    @loadCompetition="(val) => { this.loadCompetition(val)}"
                    @loadCompetitions="(val) => { this.loadCompetitions(val)}"
                    @onErrorsChange="(val)=>{this.errors = val;}"
                    @saveBegin="saveBegin"
                    @saveEnd="isDataUpdating=false"
            ></FilmForm>
				</template>
    </div>
    <div v-else style="text-align: center">
      <div class="lds-default">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import SaveInfo from "../Base/SaveInfo.vue";
import axios from "axios";
import FilmForm from "./FilmForm.vue";
import OtherPractices from "@/components/Projects/OtherPractices.vue";
import QuestionText1 from "../Base/QuestionText1.vue";
import moment from "moment";
import Pagination from "../Base/PaginationComponent.vue";


export default {
  name: 'FilmProject',
  data() {
    return {
      isLoading: false,
      isSubmitted: false,
      isDataUpdating: false,
      competitions: [],
      totalCompetitions: 0,
      isShow: false,
      selectedCompetitionId: 0,
      currentPageNum: 0,
      competitionMode: false,
      questionMode: false,
      selected_country: '',
      citiestoinput: [],
			errors: []
    }
  },
  components: {
    SaveInfo,
    Pagination,
    FilmForm,
    QuestionText1,
    OtherPractices
  },
  mounted: function () {
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      alert("Эта страница может работать некорректно в браузере Safari. Рекомендуемые браузеры Яндекс.Браузер или Google Chrome.");
    }
  },
  computed: {
    totalPages: function () {
      return Math.ceil(this.totalCompetitions / 10)
    },
    currentProjectId: function () {
      return window.projectId;
    },
    windowCompetitionId: function () {
      if (window.competitionId === undefined) {
        return '';
			}
      return window.competitionId;
    },
    selectedCompetition() {
      return this.competitions.find(el => el.id === parseInt(this.selectedCompetitionId));
    },
    other_practices() {
      return window.other_practices && window.other_practices === '1' ? true : false;
		}
  },
  methods: {
    formatCompetitionDate(date) {
      return moment(date).format('M/D/YYYY')
    },
    showModal() {
      // if (window.new.length > 0) {
      //   this.checkErrors()
      // }
      this.isShow = true;
      this.competitionMode = true;
    },
    showModalQuestion() {
      this.isShow = true;
      this.questionMode = true;
    },
    closeModal() {
      this.isShow = false
    },
    async loadCompetition(id) {
      // const response = await axios.get('/competition/apiGetCompetition/' + id + '/' + window.projectId, {
      //   headers: {
      //     'Accept': 'application/ld+json',
      //   }
      // });
      // this.competitions = [response.data];
      //this.isLoading = false;
    },
    async loadCompetitions(pageNum) {
      // this.currentPageNum = pageNum;
      // //this.isLoading = true;
			//
      // let url = '/competition/apiGetCompetitions/' + window.projectId + '/' + pageNum;
			//
      // if (pageNum === 0) {
      //   url = '/competition/apiGetCompetitions/' + window.projectId
      // }
			//
      // const response = await axios.get(url, {
      //   headers: {
      //     'Accept': 'application/ld+json',
      //   }
      // });
			//
      // this.competitions = response.data['competitions'];
      // this.totalCompetitions = response.data['total'];
      //this.isLoading = false;
    },
    setCompetitionId(id) {
      this.selectedCompetition = {};
      this.selectedCompetitionId = id;
      const self = this;
      this.isLoading = true;

      window.$.ajax({
        dataType: "json",
        type: 'get',
        contentType: "application/ld+json;",
        url: '/api/competitions/' + id,
        success: function (data) {
          if (data.projectRules !== null) {
						self.isLoading = false;
          } else {
            self.isLoading = false;
          }
        },
        error: function (data) {
          console.log(data);
        }
      });


    },
    async makeProjectInfo(categoryId, isProjectInfoSubmitted) {
      if (isProjectInfoSubmitted === '0') {
        this.isLoading = true;
        const response = await axios.get('/competition/apiAddProject/' + this.selectedCompetitionId + '/' + window.projectId + '/' + categoryId, {
          headers: {
            'Accept': 'application/ld+json',
          }
        })
        if (response.data['error']) {
          alert(response.data['error'])
        }
        await this.loadCompetitions(this.currentPageNum);
        this.isLoading = false;
      }
    },
    saveBegin() {
      this.isDataUpdating = true
		}

  }
}
</script>

<style scoped>
.field_description {
  font-size: 13px;
}

.modal {
  display: block;
  width: 80%;
  max-width: 950px;
  padding: 30px;
  box-sizing: border-box;
  background-color: #fff;
  font-size: 20px;
  text-align: center;
  margin: 30px auto 30px;
  position: relative;
}

.category_select_active {
  font-weight: bold;
}

.close_button {
  position: absolute;
  right: 15px;
  top: 10px;
  font-size: 20px;
  cursor: pointer;
}

.vue-universal-modal {
  z-index: 111;
}

.errors-block {
  color: red;
  border: 1px solid #999;
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 30px;
}

.lds-default {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  transform: scale(0.5);
  text-align: center;
}

.lds-default div {
  position: absolute;
  width: 6px;
  height: 6px;
  background: #000;
  border-radius: 50%;
  animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
  animation-delay: 0s;
  top: 37px;
  left: 66px;
}

.lds-default div:nth-child(2) {
  animation-delay: -0.1s;
  top: 22px;
  left: 62px;
}

.lds-default div:nth-child(3) {
  animation-delay: -0.2s;
  top: 11px;
  left: 52px;
}

.lds-default div:nth-child(4) {
  animation-delay: -0.3s;
  top: 7px;
  left: 37px;
}

.lds-default div:nth-child(5) {
  animation-delay: -0.4s;
  top: 11px;
  left: 22px;
}

.lds-default div:nth-child(6) {
  animation-delay: -0.5s;
  top: 22px;
  left: 11px;
}

.lds-default div:nth-child(7) {
  animation-delay: -0.6s;
  top: 37px;
  left: 7px;
}

.lds-default div:nth-child(8) {
  animation-delay: -0.7s;
  top: 52px;
  left: 11px;
}

.lds-default div:nth-child(9) {
  animation-delay: -0.8s;
  top: 62px;
  left: 22px;
}

.lds-default div:nth-child(10) {
  animation-delay: -0.9s;
  top: 66px;
  left: 37px;
}

.lds-default div:nth-child(11) {
  animation-delay: -1s;
  top: 62px;
  left: 52px;
}

.lds-default div:nth-child(12) {
  animation-delay: -1.1s;
  top: 52px;
  left: 62px;
}

.competition_wrapper {
  position: relative;
  max-width: 355px;
}

.modal .columns.is-multiline {
  justify-content: center;
}

.modal .columns.is-multiline .col1 {
  margin-right: 50px;
  margin-bottom: 70px;
}

.competiton_order_button_div {
  display: none;
}

.competition-info {
  background: #FEF4E5;
  padding: 20px;
}

.competition-image-wrapper {
  position: relative;
  display: flex;
  border-bottom: 5px solid #F69F22;
}

.choise_category h1 {
  font-size: 21px;
}

.vue-universal-modal {
  z-index: 111;
}

.competition-title__wrapper {
  line-height: 1;
}

.competition-title {
  font-size: 16px;
}

.category_select {
  font-size: 18px;
}

.content_block .tabs ul {
  align-items: inherit;
}

.content_block .tabs ul li {
  display: flex;
}

.category_select:hover {
  color: #F69F22;
  cursor: pointer;
}

.competition_wrapper_inner:hover .competiton_order_button_div {
  display: block;
}
.help_text {
  margin-bottom: 30px;
  margin-top: 30px;
  font-style: italic;
  color: #8F9194;
  cursor: pointer;
}

.help_text svg {
  margin-right: 10px;
}
.modal_question {
  text-align: left;
  font-size: 16px;
}
@keyframes lds-default {
  0%, 20%, 80%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}
</style>
